import { render, staticRenderFns } from "./RoundsReportPage.vue?vue&type=template&id=095aaac1"
import script from "./RoundsReportPage.vue?vue&type=script&lang=js"
export * from "./RoundsReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports